import React, { useLayoutEffect, useState } from "react";
import { Marker, OverlayView, OverlayViewF } from '@react-google-maps/api';
import Pin from "../Pin";
import FreePin from "../FreePin";
import deliveryProfile from "../../../../assets/delivery-man.png";
import { ClickAwayListener } from "@material-ui/core";
import styles from './style.module.css';
import { useDispatch, useSelector } from "react-redux";
import { SetActiveDriverList, SetDriverListOpenDialoge, SetDriverPopUp, SetSelectedMonitoringDriver } from "../../../../Redux/actions/actionNames";
import { GetDriverInfoAction, GetDriverOrderListAction } from "../../../../Redux/actions/actions";
import { useTranslation } from "react-i18next";
import { useDriverMonitoringPin } from "../../../../hooks/useDriverMonitoringPin";
import "./customPopup.css";
import { getOrderMonitoringBounding } from "../getOrderMonitoring";


const App = ({position, onClick ,  text , big ,color , selected , allSelected}) => {
 
 

  return <OverlayViewF
    position={position}
    
  
    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
  >
      <Pin text={text} big={big} allSelected={allSelected} onClick={onClick} color={color} style={{cursor:"pointer"}}/>
 
   </OverlayViewF>

};

export default App


 